// extracted by mini-css-extract-plugin
export default {"section":"contact_section__apu2e","content":"contact_content__RDjuC","title":"contact_title__qJFB8","buttons":"contact_buttons__0Ki3b"};